import { Model } from "../decorators/model.decorator";
import { Column } from "../decorators/column.decorator";
import { BaseModel } from "./base.model";

@Model('documents', ['document'])
export class Document extends BaseModel {
  @Column()
  id: number | undefined;
  @Column()
  slug: string | undefined;
  @Column()
  uname: string | undefined;
  @Column()
  name: string | undefined;
  @Column()
  content: string | undefined;
}
